module.exports = __webpack_public_path__ + "static/media/legende.2c6a9b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/legende.png
// module id = 314
// module chunks = 0